import type {
  StoreOpeningHours,
  UpdateOpeningHoursParams,
  UpdateSpecialOpeningHoursParams,
  WorkingHoursParams,
  WorkingHoursResponse,
} from '@/libs/interfaces'

import { mockWorkingHours } from '../fixtures/workingHours'
import { delay } from '../helpers'
import { createEntityStore } from '../store'

const workingHoursStore = createEntityStore<WorkingHoursResponse, 'storeID'>(
  mockWorkingHours,
  'storeID',
)

const emptyOpeningHours: StoreOpeningHours = {
  mondayOpen: '',
  mondayClose: '',
  tuesdayOpen: '',
  tuesdayClose: '',
  wednesdayOpen: '',
  wednesdayClose: '',
  thursdayOpen: '',
  thursdayClose: '',
  fridayOpen: '',
  fridayClose: '',
  saturdayOpen: '',
  saturdayClose: '',
  sundayOpen: '',
  sundayClose: '',
}

export const workingHoursApiMock = {
  getOpeningHours: async (params: WorkingHoursParams): Promise<WorkingHoursResponse> =>
    delay(
      workingHoursStore.getById(params.storeID) ?? {
        storeID: params.storeID,
        weekyOpeningHours: emptyOpeningHours,
        specialHours: [],
      },
    ),

  updateOpeningHours: async (params: UpdateOpeningHoursParams): Promise<StoreOpeningHours> => {
    const { storeID, ...weekyOpeningHours } = params
    const existing = workingHoursStore.getById(storeID)
    if (existing) {
      workingHoursStore.update(storeID, { weekyOpeningHours })
    } else {
      workingHoursStore.insert({
        storeID,
        weekyOpeningHours,
        specialHours: [],
      })
    }
    return delay(weekyOpeningHours)
  },

  updateSpecialOpeningHours: async (
    params: UpdateSpecialOpeningHoursParams,
  ): Promise<UpdateSpecialOpeningHoursParams> => {
    const existing = workingHoursStore.getById(params.storeID)
    if (existing) {
      workingHoursStore.update(params.storeID, {
        specialHours: params.specialHours,
      })
    } else {
      workingHoursStore.insert({
        storeID: params.storeID,
        weekyOpeningHours: emptyOpeningHours,
        specialHours: params.specialHours,
      })
    }
    return delay(params)
  },
}
